import { FONT_CATALOG } from "@/fonts/catalog";

type TextFontSvgMap = Partial<Record<string, string>>;

const textFontSvgAssets = import.meta.glob<string>("@/icons/widget-menu/text/*.svg", {
    eager: true,
    query: "?raw",
    import: "default",
});

const svgBySlug: Record<string, string> = Object.fromEntries(
    Object.entries(textFontSvgAssets).map(([path, svg]) => {
        const slug = path.replace(/^.*\//, "").replace(/\.svg(?:\?.*)?$/, "");
        return [slug, svg];
    }),
);

export const TEXT_FONT_SVGS: TextFontSvgMap = Object.fromEntries(
    FONT_CATALOG.map(({ family, slug }) => [family, svgBySlug[slug]]).filter(
        (entry): entry is [string, string] => typeof entry[1] === "string",
    ),
);

export function getTextFontSvg(fontFamily: string): string | null {
    return TEXT_FONT_SVGS[fontFamily] ?? null;
}
